var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 128",
    height: 24,
    width: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.26 91.19c0 .02 0 .04.02.07 2.66 9.12 9.68 18.55 16.76 18.55h.1c9.2-.1 30.3-8.38 48.4-26.47s26.38-39.19 26.48-48.39c.08-7.12-9.36-14.17-18.56-16.86-.02 0-.04-.02-.06-.02-1.82 4.15-4.32 9.58-6.52 14.39-1.54 3.34-2.96 6.42-3.94 8.62-.08.19-.16.35-.2.48.02.04.06.08.12.13l10.72 10.73-1.52 3.18c-.2.41-4.9 10.13-14.52 19.74-9.6 9.61-19.34 14.32-19.74 14.52l-3.2 1.52-10.72-10.73c-.04-.05-.08-.08-.12-.12-.14.06-.3.12-.5.21-2.2.98-5.3 2.4-8.64 3.94-4.8 2.2-10.22 4.7-14.36 6.51zm16.78 28.59c-12.92 0-22.7-13.33-26.34-25.72-1.78-6.11-.24-9.46 5.5-11.98 4.06-1.78 9.48-4.26 14.26-6.46 3.38-1.55 6.52-2.99 8.74-3.99 1.54-.67 3.18-1.34 5.02-1.34 3.4 0 5.64 2.24 6.7 3.31l5.6 5.58c3.24-1.94 8.66-5.57 13.98-10.89 5.32-5.31 8.94-10.72 10.9-13.97l-5.6-5.59c-4.16-4.16-3.88-7.44-1.96-11.71 1-2.23 2.42-5.35 3.98-8.73 2.2-4.78 4.68-10.2 6.46-14.27.9-2.03 2.74-6.24 7.82-6.24 1.42 0 2.84.36 4.16.75 12.5 3.66 25.88 13.52 25.74 26.53-.14 13.03-10.3 36.22-29.4 55.32-19.12 19.11-42.32 29.25-55.34 29.4h-.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.118e5f4dc9b44caa5828beb0c5950293.svg";
export { ForwardRef as ReactComponent };